import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ControlledTextField, ControllingForm, Captcha, ControlledToolbar, ControlledButton } from '../components/Form';
import DoneIcon from '@material-ui/icons/Done';
import CancelIcon from '@material-ui/icons/Cancel';
import { fetcher } from '../util/deps';
import emitter from '../emitter';
import store from '../util/store';
import { authActions } from '../redux-stuff/actions';
import { emailValidator } from '../util/validators';
import { Typography } from '@material-ui/core';
import { Box } from '@material-ui/core';

class SignUpVerify extends React.Component {
    submitHandler = async (data) => {
        try {
            const result = await fetcher.post('signup/verify', data);
            const { authorized, username, session_id: sessionId, uid } = result;
            if (authorized) {
                store.dispatch(authActions.setIsAuth(authorized));
                store.dispatch(authActions.setAuth({ authorized, username, sessionId, uid }));
            } else {
                emitter.emit('addMessage', {
                    type: 'failure',
                    data: {
                        errorMessage: 'unexpected result',
                        details: result,
                        time: new Date(),
                        agent: 'signUpVerify',

                    }
                });
            }
            this.props.history.push(`/`);
            return true;
        } catch (e) {
            emitter.emit('addMessage', { type: 'failure', data: e });
        }
    }

    render() {
        const { match: { params: { email: encodedEmail, key } } } = this.props;
        const email = encodedEmail && decodeURIComponent(encodedEmail);
        return (
            <ControllingForm name='signUpVerify' >
                <Box m={1}>
                    <Typography variant='subtitle1'>
                        <FormattedMessage id='signUp.verificatinMessage' defaultMessage='Verification key was send to your email' />
                    </Typography>
                </Box>
                <ControlledTextField
                    name='email'
                    value={email}
                    label={<FormattedMessage id='signUp.email' defaultMessage='E-mail' />}
                    required
                    autoComplete='email'
                    maxLength={255}
                    validator={emailValidator}
                />
                <ControlledTextField
                    name='key'
                    value={key}
                    label={<FormattedMessage id='signUp.verificationKey' defaultMessage='Verification key' />}
                    required
                    autoComplete='one-time-code'
                    maxLength={32}
                />
                <Captcha />
                <ControlledToolbar>
                    <ControlledButton
                        isSubmitButton
                        primary
                        icon={<DoneIcon />}
                        onClick={this.submitHandler}
                    >
                        <FormattedMessage id='signUp.submit' defaultMessage='Sign up' />
                    </ControlledButton>
                    <ControlledButton
                        icon={<CancelIcon />}
                        onClick={() => {
                            this.props.history.push('/');
                            return true;
                        }}
                    >
                        <FormattedMessage id='signUp.cancel' defaultMessage='Cancel' />
                    </ControlledButton>
                </ControlledToolbar>
            </ControllingForm>
        );
    };
};

export default SignUpVerify